"use strict";
// tslint:disable
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
function loadGoogleTagManager(measurementId) {
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', measurementId);
}
exports.default = loadGoogleTagManager;



//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/dist/gtm/loadGoogleTagManager.js
// module id = 612
// module chunks = 0 1